export enum RegimeDeContrato {
  CLT = 0,
  PJ = 1,
}
